import React from "react";
import "../styles/homeStyle.css";

export default function Jumbotron() {
  return (
    <div>
      <div className="row jumbo-container">
        <div class="col-12 jumbotron text-center">
          <h1>
            100% entertainment <span>guaranteed.</span>{" "}
          </h1>
          <p class="lead">
            You'll love Netflix! If you don't, cancel within 7 days for a
            refund.
          </p>
          <div className="search-container">
            <div class="input-group">
              <input
                className="form-control input"
                placeholder="Email address"
              />
              <div class="input-group-append">
                <button class="btn " type="button">
                  GET STARTED
                </button>
              </div>
            </div>
          </div>
          <p className="mt-2">
            Ready to watch? Enter your email to create or restart your
            membership.
          </p>
        </div>
      </div>
    </div>
  );
}
